import React from 'react';
import { Stepper, Step, StepLabel, Box } from '@mui/material';

const CustomStepper = ({ steps, activeStep, onStepClick }) => {
  // Handle step click
  const handleStepClick = (index) => {
    if (index <= activeStep) {
      onStepClick(index); // Invoke the passed callback to change step
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={index} onClick={() => handleStepClick(index)}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
